import React from 'react'
import PropTypes from 'prop-types'

const hasPermission = ({ permissions, scopes }) => {
  const scopesMap = {}
  scopes.forEach((scope) => {
    scopesMap[scope] = true
  })

  return permissions.some((permission) => scopesMap[permission])
}

const PermissionsGate = ({ children, user, scopes = [], RenderError = () => <></> }) => {

  const permissionGranted = hasPermission({ permissions: user ? user.permissions : [], scopes })

  if (!permissionGranted) return <RenderError />
  
  return (
    <>{children}</>
  )
}

PermissionsGate.propTypes = {
  children: PropTypes.node,
  user: PropTypes.any,
  scopes: PropTypes.arrayOf(PropTypes.string),
  RenderError: PropTypes.func
}

export default PermissionsGate